module.exports = __webpack_public_path__ + "img/invalid_stamp.1a860312.png";